import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { Observable, fromEvent } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Globals } from '../globals';
import { UserModel } from '../model/IUser';
import { Store, select } from '@ngrx/store';
import * as fromUser from '../state/user.reducer';
import * as userAction from '../state/user.action';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private httpHeader = new HttpHeaders();
  private serviceModule = 'Authentication';

  constructor(private http: HttpClient, private _global: Globals, private store: Store<fromUser.UserState>, private configService: ConfigurationsService) {

    this.httpHeader.append('Access-Control-Allow-Origin', '*');

  }

  // Check user is LoggedIn or not
  isUserLoggedIn(): boolean {
    var loggedInUser;
    this.store.pipe(select(fromUser.getLoggedInuser)).subscribe(user => {
      if (user && user.UserId) {
        loggedInUser = true;
      }
      else {
        loggedInUser = false;
      }
    }
    );

    return loggedInUser;
  }

  // Method is used for get Form wise validation message
  getValidationMessage(): Observable<any> {
    return this.http.get('assets/validation.json').pipe(
      map((result) => {
        this._global.validationObject = result;
        return result;
      }));
  }

  // Method is used for Authenticate user of application
  authentication(UserName: string, Password: string, CompanyCode: string) {
    // Set up
    let httpOptions = {
      headers: this.httpHeader
    };
    let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Login' + '/GetLoginDetails?userName=' + UserName + '&password=' + Password + '&companycode=' + CompanyCode;

    return this.http.get(serviceCallURL)
      .pipe(
        map((resp: any) => {
          let username = resp.FirstName + ' ' + resp.LastName;
          localStorage.setItem('UserName', username);
          localStorage.setItem('UserRole', resp.RoleName);
          localStorage.setItem('UserId', resp.UserId.toString());
          localStorage.setItem('LoginId', resp.LoginId);
          localStorage.setItem('CompanyIdForUC', resp.CompanyId);
          localStorage.setItem('RoleName', resp.RoleDetailList[0].RoleName);
          localStorage.setItem('ScreenList', JSON.stringify(resp.ScreenDetailList));
          localStorage.setItem('UserPref', resp.UserPrefJson);
          this.store.dispatch(new userAction.LogOutUser());
          this.store.dispatch(new userAction.SetCurrentUser(resp));
          return resp;
        }),
        catchError(this._global.handleError)
      );
  }

  // Method is used for Register user
  RegisterUser(userReq): Observable<UserModel> {
    let httpOptions = {
      headers: this.httpHeader
    };
    return this.http.post(this.configService.serviceUrl('ServiceURL') + 'SignUp' + '/SignUpUser', userReq, httpOptions).pipe(
      map((resp: UserModel) => resp),
      catchError(this._global.handleError)

    );
  }

  // Method is used for Get Login User Details
  getLoggedInUser(): UserModel {
    var Loginuser;
    this.store.pipe(select(fromUser.getLoggedInuser)).subscribe(user => {
      Loginuser = user;
    }
    );
    return Loginuser;
  }

  // Method is used for Send Password
  SendPassword(LoginId, CompanyCode) {
    let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'ForgotPassword' + '/ForgotPassword?LoginId=' + LoginId + '&CompanyCode=' + CompanyCode;
    return this.http.get(serviceCallURL)
      .pipe(map((resp: any) => resp),
        catchError(this._global.handleError)
      );
  }

  // Method is used for Reset PW
  ResetPW(ReqObj: any) {
    let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'ResetPassword' + '/ResetPassword';
    return this.http.post(serviceCallURL, ReqObj)
      .pipe(map((resp: any) => resp),
        catchError(this._global.handleError)
      );
  }

  // logOut user
  logOut() {
    this.store.dispatch(new userAction.LogOutUser());
    const SelectedReports = localStorage.getItem('SelectedReports');
    const ThresholdReportSearchData = localStorage.getItem('ThresholdReportSearchData');
    const AverageConsumptionReportParams = localStorage.getItem('AverageConsumptionReportParams');
    const TotalConsumptionReportParams = localStorage.getItem('TotalConsumptionReportParams');
    const InsightDashboard = localStorage.getItem('InsightDashboard');
    const DebtronicsDashboardData = localStorage.getItem('DebtronicsDashboardData');
    localStorage.clear();
    setTimeout(() => {
      if (SelectedReports !== null) {
        localStorage.setItem('SelectedReports', SelectedReports);
      }
      if (ThresholdReportSearchData !== null) {
        localStorage.setItem('ThresholdReportSearchData', ThresholdReportSearchData);
      }
      if (AverageConsumptionReportParams !== null) {
        localStorage.setItem('AverageConsumptionReportParams', AverageConsumptionReportParams);
      }
      if (TotalConsumptionReportParams !== null) {
        localStorage.setItem('TotalConsumptionReportParams', TotalConsumptionReportParams);
      }
      if (InsightDashboard !== null) {
        localStorage.setItem('InsightDashboard', InsightDashboard);
      }
      if (DebtronicsDashboardData !== null) {
        localStorage.setItem('DebtronicsDashboardData', DebtronicsDashboardData);
      }
    }, 2000);
  }
}
